<template>
  <div id="exhpredictionApprove">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'exhprediction'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhprediction/ExhpredictionApprove.vue